export default __webpack_public_path__ + "static/media/places.7502a8e1.svg";